var _style, _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 560",
    style: {
      enableBackground: "new 0 0 650 560"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t\n\t\t.st1{fill:none;stroke:url(#SVGID_1_);stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:34.6217,34.6217;}\n\t.st2{fill:#29266E;}\n\t.st3{fill:#666666;}\n\t.st4{fill:#194BED;}\n\t.st5{fill:#F05A28;}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 325,
    cy: 281,
    r: 275.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 47,
    y1: 281,
    x2: 603,
    y2: 281
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05A28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#29266E"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 325,
    cy: 281,
    r: 275.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.4,429.73c-0.84,1.12-2.07,0.78-3.17,0.78c-23.88,0.01-47.77-0.02-71.65,0.04 c-2.28,0.01-3.14-0.05-2.04-2.75c43.68-107.6,87.29-215.23,130.9-322.86c0.15-0.37,0.32-0.74,0.51-1.18 c1.3,0.87,1.47,2.31,1.99,3.49c11.83,26.85,23.6,53.74,35.47,80.57c0.81,1.83,0.6,3.27-0.07,4.98 c-18.31,46.95-36.59,93.92-54.86,140.89c-0.45,1.15-0.76,2.36-1.13,3.54c-0.5,1.02-1.07,2-1.48,3.05 c-9.94,25.45-19.91,50.88-29.73,76.38c-1.54,4-3.77,7.83-4.08,12.25l0.01-0.01C221.54,428.92,221.42,429.28,221.4,429.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.52,152.29c4.45,10.94,8.96,21.87,13.35,32.84c32.04,80.15,64.06,160.31,96.09,240.47 c0.15,0.39,0.26,0.79,0.47,1.15c1.24,2.22,0.41,2.64-1.87,2.64c-23.78-0.01-47.57,0.05-71.35,0.21c-2.3,0.02-3.16-0.78-3.94-2.81 c-33.21-86.71-66.45-173.4-99.78-260.06c-1.85-4.82-4.15-9.48-5.65-14.45c0.27-0.25,0.55-0.5,0.82-0.74 c8.99-0.05,17.99-0.14,26.98-0.13c14.68,0.01,29.37,0.09,44.05,0.14C394.96,151.8,395.24,152.04,395.52,152.29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222.07,428.92c0.32-4.43,2.54-8.25,4.08-12.25c9.81-25.5,19.79-50.93,29.73-76.38 c0.41-1.05,0.99-2.04,1.48-3.05c22.63-4.76,45.27-9.52,67.9-14.27c11.77-2.47,23.53-4.93,35.37-7.41c0.12,1.16-0.82,1.41-1.37,1.85 c-45.03,36.79-90.07,73.55-135.12,110.31C223.54,428.22,223.04,429,222.07,428.92z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M290.51,68c22.3,0.02,44.59,0.04,66.89,0.06c1.55,0,3.11,0.05,4.66,0.08c7.82,19.54,15.61,39.09,23.49,58.6 c0.84,2.07,0.53,2.63-1.77,2.63c-22.52-0.06-45.05-0.05-67.57-0.02c-1.45,0-2.5-0.13-3.13-1.77c-7.48-19.67-15.02-39.31-22.54-58.97 C290.48,68.43,290.52,68.21,290.51,68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.96ef1e29dec17c934367637e1ff75de4.svg";
export { ForwardRef as ReactComponent };